import * as W from "react";
import { forwardRef as pr, useContext as br } from "react";
import { _ as gr } from "./extends.js";
var wr = !1;
function yr(r) {
  if (r.sheet)
    return r.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === r)
      return document.styleSheets[e];
}
function kr(r) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", r.key), r.nonce !== void 0 && e.setAttribute("nonce", r.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var mr = /* @__PURE__ */ function() {
  function r(n) {
    var t = this;
    this._insertTag = function(a) {
      var c;
      t.tags.length === 0 ? t.insertionPoint ? c = t.insertionPoint.nextSibling : t.prepend ? c = t.container.firstChild : c = t.before : c = t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(a, c), t.tags.push(a);
    }, this.isSpeedy = n.speedy === void 0 ? !wr : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var e = r.prototype;
  return e.hydrate = function(t) {
    t.forEach(this._insertTag);
  }, e.insert = function(t) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(kr(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var c = yr(a);
      try {
        c.insertRule(t, c.cssRules.length);
      } catch {
      }
    } else
      a.appendChild(document.createTextNode(t));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(t) {
      var a;
      return (a = t.parentNode) == null ? void 0 : a.removeChild(t);
    }), this.tags = [], this.ctr = 0;
  }, r;
}(), k = "-ms-", Y = "-moz-", i = "-webkit-", cr = "comm", V = "rule", X = "decl", vr = "@import", ir = "@keyframes", xr = "@layer", $r = Math.abs, U = String.fromCharCode, lr = Object.assign;
function Cr(r, e) {
  return b(r, 0) ^ 45 ? (((e << 2 ^ b(r, 0)) << 2 ^ b(r, 1)) << 2 ^ b(r, 2)) << 2 ^ b(r, 3) : 0;
}
function sr(r) {
  return r.trim();
}
function Tr(r, e) {
  return (r = e.exec(r)) ? r[0] : r;
}
function s(r, e, n) {
  return r.replace(e, n);
}
function G(r, e) {
  return r.indexOf(e);
}
function b(r, e) {
  return r.charCodeAt(e) | 0;
}
function z(r, e, n) {
  return r.slice(e, n);
}
function A(r) {
  return r.length;
}
function rr(r) {
  return r.length;
}
function D(r, e) {
  return e.push(r), r;
}
function Er(r, e) {
  return r.map(e).join("");
}
var Z = 1, N = 1, or = 0, x = 0, d = 0, O = "";
function j(r, e, n, t, a, c, p) {
  return { value: r, root: e, parent: n, type: t, props: a, children: c, line: Z, column: N, length: p, return: "" };
}
function L(r, e) {
  return lr(j("", null, null, "", null, null, 0), r, { length: -r.length }, e);
}
function Ar() {
  return d;
}
function Sr() {
  return d = x > 0 ? b(O, --x) : 0, N--, d === 10 && (N = 1, Z--), d;
}
function l() {
  return d = x < or ? b(O, x++) : 0, N++, d === 10 && (N = 1, Z++), d;
}
function S() {
  return b(O, x);
}
function F() {
  return x;
}
function q(r, e) {
  return z(O, r, e);
}
function I(r) {
  switch (r) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function fr(r) {
  return Z = N = 1, or = A(O = r), x = 0, [];
}
function ur(r) {
  return O = "", r;
}
function H(r) {
  return sr(q(x - 1, J(r === 91 ? r + 2 : r === 40 ? r + 1 : r)));
}
function Pr(r) {
  for (; (d = S()) && d < 33; )
    l();
  return I(r) > 2 || I(d) > 3 ? "" : " ";
}
function Rr(r, e) {
  for (; --e && l() && !(d < 48 || d > 102 || d > 57 && d < 65 || d > 70 && d < 97); )
    ;
  return q(r, F() + (e < 6 && S() == 32 && l() == 32));
}
function J(r) {
  for (; l(); )
    switch (d) {
      case r:
        return x;
      case 34:
      case 39:
        r !== 34 && r !== 39 && J(d);
        break;
      case 40:
        r === 41 && J(r);
        break;
      case 92:
        l();
        break;
    }
  return x;
}
function Mr(r, e) {
  for (; l() && r + d !== 57; )
    if (r + d === 84 && S() === 47)
      break;
  return "/*" + q(e, x - 1) + "*" + U(r === 47 ? r : l());
}
function _r(r) {
  for (; !I(S()); )
    l();
  return q(r, x);
}
function Nr(r) {
  return ur(K("", null, null, null, [""], r = fr(r), 0, [0], r));
}
function K(r, e, n, t, a, c, p, u, m) {
  for (var C = 0, g = 0, w = p, P = 0, R = 0, $ = 0, f = 1, v = 1, h = 1, y = 0, T = "", B = a, M = c, E = t, o = T; v; )
    switch ($ = y, y = l()) {
      case 40:
        if ($ != 108 && b(o, w - 1) == 58) {
          G(o += s(H(y), "&", "&\f"), "&\f") != -1 && (h = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        o += H(y);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        o += Pr($);
        break;
      case 92:
        o += Rr(F() - 1, 7);
        continue;
      case 47:
        switch (S()) {
          case 42:
          case 47:
            D(Or(Mr(l(), F()), e, n), m);
            break;
          default:
            o += "/";
        }
        break;
      case 123 * f:
        u[C++] = A(o) * h;
      case 125 * f:
      case 59:
      case 0:
        switch (y) {
          case 0:
          case 125:
            v = 0;
          case 59 + g:
            h == -1 && (o = s(o, /\f/g, "")), R > 0 && A(o) - w && D(R > 32 ? tr(o + ";", t, n, w - 1) : tr(s(o, " ", "") + ";", t, n, w - 2), m);
            break;
          case 59:
            o += ";";
          default:
            if (D(E = er(o, e, n, C, g, a, u, T, B = [], M = [], w), c), y === 123)
              if (g === 0)
                K(o, e, E, E, B, c, w, u, M);
              else
                switch (P === 99 && b(o, 3) === 110 ? 100 : P) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    K(r, E, E, t && D(er(r, E, E, 0, 0, a, u, T, a, B = [], w), M), a, M, w, u, t ? B : M);
                    break;
                  default:
                    K(o, E, E, E, [""], M, 0, u, M);
                }
        }
        C = g = R = 0, f = h = 1, T = o = "", w = p;
        break;
      case 58:
        w = 1 + A(o), R = $;
      default:
        if (f < 1) {
          if (y == 123)
            --f;
          else if (y == 125 && f++ == 0 && Sr() == 125)
            continue;
        }
        switch (o += U(y), y * f) {
          case 38:
            h = g > 0 ? 1 : (o += "\f", -1);
            break;
          case 44:
            u[C++] = (A(o) - 1) * h, h = 1;
            break;
          case 64:
            S() === 45 && (o += H(l())), P = S(), g = w = A(T = o += _r(F())), y++;
            break;
          case 45:
            $ === 45 && A(o) == 2 && (f = 0);
        }
    }
  return c;
}
function er(r, e, n, t, a, c, p, u, m, C, g) {
  for (var w = a - 1, P = a === 0 ? c : [""], R = rr(P), $ = 0, f = 0, v = 0; $ < t; ++$)
    for (var h = 0, y = z(r, w + 1, w = $r(f = p[$])), T = r; h < R; ++h)
      (T = sr(f > 0 ? P[h] + " " + y : s(y, /&\f/g, P[h]))) && (m[v++] = T);
  return j(r, e, n, a === 0 ? V : u, m, C, g);
}
function Or(r, e, n) {
  return j(r, e, n, cr, U(Ar()), z(r, 2, -2), 0);
}
function tr(r, e, n, t) {
  return j(r, e, n, X, z(r, 0, t), z(r, t + 1, -1), t);
}
function _(r, e) {
  for (var n = "", t = rr(r), a = 0; a < t; a++)
    n += e(r[a], a, r, e) || "";
  return n;
}
function Lr(r, e, n, t) {
  switch (r.type) {
    case xr:
      if (r.children.length) break;
    case vr:
    case X:
      return r.return = r.return || r.value;
    case cr:
      return "";
    case ir:
      return r.return = r.value + "{" + _(r.children, t) + "}";
    case V:
      r.value = r.props.join(",");
  }
  return A(n = _(r.children, t)) ? r.return = r.value + "{" + n + "}" : "";
}
function Wr(r) {
  var e = rr(r);
  return function(n, t, a, c) {
    for (var p = "", u = 0; u < e; u++)
      p += r[u](n, t, a, c) || "";
    return p;
  };
}
function zr(r) {
  return function(e) {
    e.root || (e = e.return) && r(e);
  };
}
var nr = function(e) {
  var n = /* @__PURE__ */ new WeakMap();
  return function(t) {
    if (n.has(t))
      return n.get(t);
    var a = e(t);
    return n.set(t, a), a;
  };
}, Ir = function(e, n, t) {
  for (var a = 0, c = 0; a = c, c = S(), a === 38 && c === 12 && (n[t] = 1), !I(c); )
    l();
  return q(e, x);
}, qr = function(e, n) {
  var t = -1, a = 44;
  do
    switch (I(a)) {
      case 0:
        a === 38 && S() === 12 && (n[t] = 1), e[t] += Ir(x - 1, n, t);
        break;
      case 2:
        e[t] += H(a);
        break;
      case 4:
        if (a === 44) {
          e[++t] = S() === 58 ? "&\f" : "", n[t] = e[t].length;
          break;
        }
      default:
        e[t] += U(a);
    }
  while (a = l());
  return e;
}, Br = function(e, n) {
  return ur(qr(fr(e), n));
}, ar = /* @__PURE__ */ new WeakMap(), Dr = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var n = e.value, t = e.parent, a = e.column === t.column && e.line === t.line; t.type !== "rule"; )
      if (t = t.parent, !t) return;
    if (!(e.props.length === 1 && n.charCodeAt(0) !== 58 && !ar.get(t)) && !a) {
      ar.set(e, !0);
      for (var c = [], p = Br(n, c), u = t.props, m = 0, C = 0; m < p.length; m++)
        for (var g = 0; g < u.length; g++, C++)
          e.props[C] = c[m] ? p[m].replace(/&\f/g, u[g]) : u[g] + " " + p[m];
    }
  }
}, Fr = function(e) {
  if (e.type === "decl") {
    var n = e.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
};
function hr(r, e) {
  switch (Cr(r, e)) {
    case 5103:
      return i + "print-" + r + r;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return i + r + r;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return i + r + Y + r + k + r + r;
    case 6828:
    case 4268:
      return i + r + k + r + r;
    case 6165:
      return i + r + k + "flex-" + r + r;
    case 5187:
      return i + r + s(r, /(\w+).+(:[^]+)/, i + "box-$1$2" + k + "flex-$1$2") + r;
    case 5443:
      return i + r + k + "flex-item-" + s(r, /flex-|-self/, "") + r;
    case 4675:
      return i + r + k + "flex-line-pack" + s(r, /align-content|flex-|-self/, "") + r;
    case 5548:
      return i + r + k + s(r, "shrink", "negative") + r;
    case 5292:
      return i + r + k + s(r, "basis", "preferred-size") + r;
    case 6060:
      return i + "box-" + s(r, "-grow", "") + i + r + k + s(r, "grow", "positive") + r;
    case 4554:
      return i + s(r, /([^-])(transform)/g, "$1" + i + "$2") + r;
    case 6187:
      return s(s(s(r, /(zoom-|grab)/, i + "$1"), /(image-set)/, i + "$1"), r, "") + r;
    case 5495:
    case 3959:
      return s(r, /(image-set\([^]*)/, i + "$1$`$1");
    case 4968:
      return s(s(r, /(.+:)(flex-)?(.*)/, i + "box-pack:$3" + k + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + i + r + r;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return s(r, /(.+)-inline(.+)/, i + "$1$2") + r;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (A(r) - 1 - e > 6) switch (b(r, e + 1)) {
        case 109:
          if (b(r, e + 4) !== 45) break;
        case 102:
          return s(r, /(.+:)(.+)-([^]+)/, "$1" + i + "$2-$3$1" + Y + (b(r, e + 3) == 108 ? "$3" : "$2-$3")) + r;
        case 115:
          return ~G(r, "stretch") ? hr(s(r, "stretch", "fill-available"), e) + r : r;
      }
      break;
    case 4949:
      if (b(r, e + 1) !== 115) break;
    case 6444:
      switch (b(r, A(r) - 3 - (~G(r, "!important") && 10))) {
        case 107:
          return s(r, ":", ":" + i) + r;
        case 101:
          return s(r, /(.+:)([^;!]+)(;|!.+)?/, "$1" + i + (b(r, 14) === 45 ? "inline-" : "") + "box$3$1" + i + "$2$3$1" + k + "$2box$3") + r;
      }
      break;
    case 5936:
      switch (b(r, e + 11)) {
        case 114:
          return i + r + k + s(r, /[svh]\w+-[tblr]{2}/, "tb") + r;
        case 108:
          return i + r + k + s(r, /[svh]\w+-[tblr]{2}/, "tb-rl") + r;
        case 45:
          return i + r + k + s(r, /[svh]\w+-[tblr]{2}/, "lr") + r;
      }
      return i + r + k + r + r;
  }
  return r;
}
var Hr = function(e, n, t, a) {
  if (e.length > -1 && !e.return) switch (e.type) {
    case X:
      e.return = hr(e.value, e.length);
      break;
    case ir:
      return _([L(e, {
        value: s(e.value, "@", "@" + i)
      })], a);
    case V:
      if (e.length) return Er(e.props, function(c) {
        switch (Tr(c, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return _([L(e, {
              props: [s(c, /:(read-\w+)/, ":" + Y + "$1")]
            })], a);
          case "::placeholder":
            return _([L(e, {
              props: [s(c, /:(plac\w+)/, ":" + i + "input-$1")]
            }), L(e, {
              props: [s(c, /:(plac\w+)/, ":" + Y + "$1")]
            }), L(e, {
              props: [s(c, /:(plac\w+)/, k + "input-$1")]
            })], a);
        }
        return "";
      });
  }
}, Kr = [Hr], Yr = function(e) {
  var n = e.key;
  if (n === "css") {
    var t = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(t, function(f) {
      var v = f.getAttribute("data-emotion");
      v.indexOf(" ") !== -1 && (document.head.appendChild(f), f.setAttribute("data-s", ""));
    });
  }
  var a = e.stylisPlugins || Kr, c = {}, p, u = [];
  p = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(f) {
      for (var v = f.getAttribute("data-emotion").split(" "), h = 1; h < v.length; h++)
        c[v[h]] = !0;
      u.push(f);
    }
  );
  var m, C = [Dr, Fr];
  {
    var g, w = [Lr, zr(function(f) {
      g.insert(f);
    })], P = Wr(C.concat(a, w)), R = function(v) {
      return _(Nr(v), P);
    };
    m = function(v, h, y, T) {
      g = y, R(v ? v + "{" + h.styles + "}" : h.styles), T && ($.inserted[h.name] = !0);
    };
  }
  var $ = {
    key: n,
    sheet: new mr({
      key: n,
      container: p,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: c,
    registered: {},
    insert: m
  };
  return $.sheet.hydrate(u), $;
}, dr = /* @__PURE__ */ W.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Yr({
    key: "css"
  }) : null
);
dr.Provider;
var Jr = function(e) {
  return /* @__PURE__ */ pr(function(n, t) {
    var a = br(dr);
    return e(n, a, t);
  });
}, Q = /* @__PURE__ */ W.createContext({}), Qr = function() {
  return W.useContext(Q);
}, Ur = function(e, n) {
  if (typeof n == "function") {
    var t = n(e);
    return t;
  }
  return gr({}, e, n);
}, Zr = /* @__PURE__ */ nr(function(r) {
  return nr(function(e) {
    return Ur(r, e);
  });
}), Vr = function(e) {
  var n = W.useContext(Q);
  return e.theme !== n && (n = Zr(n)(e.theme)), /* @__PURE__ */ W.createElement(Q.Provider, {
    value: n
  }, e.children);
};
export {
  Q as T,
  Vr as a,
  Qr as u,
  Jr as w
};
